import {
  Button,
  Columns,
  Container,
  Heading,
  Stack,
  Text,
} from '@spaceship-fspl/components';
import { height, match, width } from '@spaceship-fspl/styles';
import { PanelSection } from 'components';
import * as React from 'react';
import styled from 'styled-components';

import ImgLeftPeople from './img-hiring-faces-left.png';
import ImgRightPeople from './img-hiring-faces-right.png';
import ImgMobileBottomPeople from './img-mobile-hiring-faces-bottom.png';
import ImgMobileTopPeople from './img-mobile-hiring-faces-top.png';

const LeftImageContainer = styled.div`
  ${match('md')`
    direction: rtl;
  `}
`;

const LeftImage = styled.div`
  ${height({ xs: 155, md: 173, lg: 408 })}
  ${width({ xs: 175, md: 116, lg: 273 })}
  background-image: url(${ImgMobileTopPeople});
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0 auto;

  ${match('md')`
    background-image: url(${ImgLeftPeople});
  `}
`;

const RightImage = styled(LeftImage)`
  ${height({ xs: 165, md: 174, lg: 408 })}
  ${width({ xs: 174, md: 128, lg: 299 })}
  background-image: url(${ImgMobileBottomPeople});

  ${match('md')`
    background-image: url(${ImgRightPeople});
  `}
`;

export interface HiringPanelProps {
  title: string;
  tagline: string;
}

export const HiringPanel: React.FC<
  React.PropsWithChildren<HiringPanelProps>
> = ({ title, tagline }) => (
  <PanelSection display="flex" justifyContent="center">
    <Container>
      <Columns
        alignY={{ md: 'center' }}
        spaceX={{ xs: 'none', md: 'md', lg: 'xl' }}
        spaceY={{ xs: 'lg', md: 'none' }}
      >
        <Columns.Column width={{ xs: 1, md: 1 / 8, lg: 2 / 12 }}>
          <LeftImageContainer>
            <LeftImage />
          </LeftImageContainer>
        </Columns.Column>

        <Columns.Column width={{ xs: 1, md: 6 / 8, lg: 8 / 12 }}>
          <Stack spaceY="lg" alignX="center">
            <Stack spaceY="md">
              <Heading variant={2} align="center">
                {title}
              </Heading>
              <Text variant={1} align="center" color="neutral.085">
                {tagline}
              </Text>
            </Stack>
            <Button variant="primary" size="lg" href="/careers/">
              See where you fit in
            </Button>
          </Stack>
        </Columns.Column>

        <Columns.Column width={{ xs: 1, md: 1 / 8, lg: 2 / 12 }}>
          <RightImage />
        </Columns.Column>
      </Columns>
    </Container>
  </PanelSection>
);
